<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Modèle de SMS</mat-label>
            <mat-select data-select-templateId formControlName="templateId" required tabindex="10">
                @for (item of _smsTemplates; track item) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['templateId']?.required && (dataForm.controls['templateId']?.dirty || dataForm.controls['templateId'].touched)) {
                <mat-error data-input-role-error>Le champ 'Modèle de SMS' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Modèle de mail" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-checkbox class="with-info-icon accent-button" formControlName="dontSendIfRecipientMissingEnabled" tabindex="11">
            Ne pas envoyer lorsqu'un destinataire est manquant.
        </mat-checkbox>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            matTooltip="Si cette option est activé, le SMS ne sera pas envoyé si au moins un des destinataires est manquant. Si cette option est désactivée, Un SMS sera envoyé aux destinataires renseignés uniquement"
            matTooltipPosition="right"></fa-icon>
    </div>
</form>
